import { capitalize } from 'lodash'

import {
  Button,
  LabelValue,
  TokenBalance,
} from '~/components/component-library'
import { SwapQuote } from '~/components/forms/swap/hooks/useSwap'
import { SponsoredBadge } from '~/components/txn-display/cost-display/SponsoredBadge'
import { useOrgPlan } from '~/hooks/useOrgPlan'
import { usePlanAccess } from '~/hooks/usePlanAccess'
import { bpsToPercentage, getSwapFee } from '~/utils/swap'

export const SwapFeeReviewDetail = ({ quote }: { quote?: SwapQuote }) => {
  const { data: orgPlan } = useOrgPlan()
  const { isEnforced } = usePlanAccess('pro')

  const swapFee = quote && getSwapFee(quote)
  if (!swapFee) return null

  const plan = isEnforced ? orgPlan?.plan : undefined
  const showUpgrade = plan === 'base'
  const paidPlanLabel = plan && plan !== 'base' ? capitalize(plan) : undefined
  const isDiscounted = swapFee.amount < swapFee.standardAmount
  const isFree = swapFee.amount === 0n

  const feeAmount = (amount: bigint) => (
    <TokenBalance
      address={swapFee.token}
      chainId={swapFee.chainId}
      tokenAmount={amount}
      layout="inline"
      size="small"
      direction="neutral"
    />
  )

  return (
    <LabelValue
      size="small"
      label="Swap fee"
      secondaryLabel={
        swapFee.bps ? `${bpsToPercentage(swapFee.bps)}%` : undefined
      }
      tooltip="Estimated from the quoted swap rate and sell amount. Included in the quote."
      value={
        <div className="flex items-center gap-2 text-sm">
          {showUpgrade && (
            <Button
              variant="secondaryAction"
              href={{ path: '/settings/team/upgrade?plan=pro', target: 'tab' }}
            >
              Upgrade
            </Button>
          )}
          {paidPlanLabel && <SponsoredBadge label={paidPlanLabel} />}
          {isDiscounted && (
            <span className="text-secondary line-through">
              {feeAmount(swapFee.standardAmount)}
            </span>
          )}
          {isFree ? <span>Free</span> : feeAmount(swapFee.amount)}
        </div>
      }
    />
  )
}
